export default __webpack_public_path__ + "static/media/l22.a7fa0809.png";